import { FC } from 'react';

type Props = {
	className?: string;
};

const CopyIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M8.40039 12.1001C8.40039 10.1202 8.40039 9.13022 9.01547 8.51511C9.63058 7.90002 10.6205 7.90002 12.6004 7.90002H13.3004C15.2803 7.90002 16.2703 7.90002 16.8854 8.51511C17.5005 9.13022 17.5005 10.1202 17.5005 12.1001V12.8001C17.5005 14.78 17.5005 15.7699 16.8854 16.385C16.2703 17.0001 15.2803 17.0001 13.3004 17.0001H12.6004C10.6205 17.0001 9.63058 17.0001 9.01547 16.385C8.40039 15.7699 8.40039 14.78 8.40039 12.8001V12.1001Z'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14 7.90005C13.9984 5.83007 13.9671 4.75787 13.3645 4.02371C13.2482 3.88193 13.1182 3.75193 12.9764 3.63558C12.2019 3 11.0513 3 8.75006 3C6.4488 3 5.29817 3 4.52371 3.63558C4.38193 3.75193 4.25193 3.88193 4.13558 4.02371C3.5 4.79817 3.5 5.9488 3.5 8.25006C3.5 10.5513 3.5 11.7019 4.13558 12.4764C4.25193 12.6182 4.38193 12.7482 4.52371 12.8645C5.25787 13.4671 6.33007 13.4984 8.40005 13.5'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default CopyIcon;
